module.exports = __webpack_public_path__ + "static/4-4d0fed821ddef6c61de727ab87b3db87.jpg";